export const DEFAULT_SAVE_TIMEOUT = 5000;

export const COMMANDS = {
    clear: 'clear',
    finishEditing: 'finishEditing',
    onEmptyBackspace: 'onEmptyBackspace',
};
